'use client';

import Image from '@repo/ui/src/components/Image';
import LoadingLogo from '@components/Loading/LoadingLogo';
import { useRemoveGCFromBasket } from '@hooks/basket/useRemoveGCFromBasket';
import { GiftCard } from '@repo/ui/src/types/basket';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import getCurrencySymbol from '@functions/country-functions';
import useBasket from '@hooks/basket/useBasket';
import { classNames } from '@repo/ui/src/utils/classNames';

interface Props {
  editable?: boolean;
  giftCard: GiftCard;
}

const GiftCardLineItem = ({ editable, giftCard }: Props) => {
  const { trigger, isMutating } = useRemoveGCFromBasket();
  const { data: basket } = useBasket();
  const currencySymbol = getCurrencySymbol(basket?.currency);
  const { t } = useTranslation();

  return (
    <li>
      <div
        className={classNames(
          'tw-w-full tw-grid  tw-gap-x-6 tw-py-6',
          editable ? 'tw-grid-cols-[20%_3fr_1fr]' : 'tw-grid-cols-[14%_3fr_1fr]',
        )}
      >
        <div className="tw-relative">
          <Image
            src="/icons/gift-card-no-background.png"
            alt="Gift Card Product Image"
            layout="responsive"
            width={96}
            height={50}
          />
        </div>

        <div>
          <p className={classNames('tra-text-web-body-m tw-text-left', editable && 'tw-font-bold')}>
            {t('cart.lineItemText.giftCardTitle', undefined, { default: 'Gift Card' })}
          </p>
        </div>
        <div className="tw-flex tw-flex-col tw-justify-between tw-items-end">
          <p className={classNames('tra-text-web-body-m')}>
            {currencySymbol || '$'}
            {giftCard.amount.toFixed(2)}
          </p>
          {editable &&
            (isMutating ? (
              <LoadingLogo />
            ) : (
              <button
                className="tw-underline tra-text-web-body-m"
                onClick={() => trigger(giftCard)}
              >
                {t('cart.cartRemoveText', undefined, { default: 'Remove' })}
              </button>
            ))}
        </div>
      </div>
      {editable && <hr className="tw-w-full tw-border-b tw-border tw-border-warm-200 tw-my-0" />}
    </li>
  );
};

export default GiftCardLineItem;
